import React, { useEffect, useMemo, useState } from 'react';
import {
  collection,
  doc,
  onSnapshot,
  setDoc,
  query,
  where,
  getDocs,
  updateDoc,
  arrayUnion,
} from 'firebase/firestore';
import { db } from '../firebase';
import User from '../components/user';
import WhatsApp from '../components/whatsApp';
import Document from "../components/document";
import Gala from '../components/gala';
import WaiterUser from '../components/waiterUser';

export default function Waiters({isToogle}) {

  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [locations, setLocations] = useState([]);

  const [searcher, setSearcher] = useState("");
  const [filter, setFilter] = useState("");
  const [actualGroup, setActualGroup] = useState("");

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "locations"), (snapshot) => {
      const l = snapshot.docs
        .map(doc => doc.data() || {})
        .flatMap(obj => Object.values(obj || {}))
        .filter(Boolean);
      setLocations(l);
    }, (err) => {
      console.error("Błąd pobierania lokalizacji:", err);
      setLocations([]);
    });

    return () => unsub();
  }, []);

  // --- USERS ---
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "users2026"), (snapshot) => {
      const data = snapshot.docs.map(d => d.data());
      const clients = [];
      for (let i = 0; i < data.length; i++) {
        const su = data[i]?.subUsers || {};
        for (const k of Object.keys(su)) {
          clients.push({ uid: data[i]?.uid, acc: data[i], user: su[k] });
        }
      }
      setUsers(clients);
    });
    return () => unsub();
  }, []);

  // --- GROUPS (jeden dokument, ID stałe) ---
  useEffect(() => {
    const TARGET_ID = "SPdqELFz2ovWSn8eFyws";
    const ref = doc(db, "groups", TARGET_ID);
    const unsub = onSnapshot(ref, (snap) => {
      if (!snap.exists()) { setGroups([]); return; }
      const data = snap.data() || {};
      const arr = Object.values(data).filter(Boolean);
      setGroups(arr);
    }, (err) => {
      console.error("Błąd pobierania grup:", err);
      setGroups([]);
    });
    return () => unsub();
  }, []);

  const userList = () => {
    if (!users) return null;

    // 1) tylko do weryfikacji
    let filtered = users.filter(u => u?.user?.toVerificate === true);

    // 2) wyszukiwarka
    if (searcher) {
      const srch = searcher.trim().toUpperCase();
      filtered = filtered.filter(u =>
        (u?.user?.displayName || "").toUpperCase().includes(srch) ||
        (u?.acc?.parent?.displayName || "").toUpperCase().includes(srch) ||
        (u?.acc?.email || "").toUpperCase().includes(srch) ||
        (u?.acc?.uid || "").toUpperCase().includes(srch) ||
        (u?.acc?.parent?.phone || "").toUpperCase().includes(srch) ||
        (u?.user?.pesel || "").toUpperCase().includes(srch) ||
        (u?.user?.dateOfBirth || "").toUpperCase().includes(srch)
      );
    }
    // 3) filtr po grupie
    else if (actualGroup) {
      filtered = filtered.filter(u => (u?.user?.groups || []).includes(actualGroup));
    }

    // 4) sortowanie po nazwisku
    filtered.sort((a, b) =>
      (a?.user?.displayName || "").localeCompare(
        (b?.user?.displayName || ""),
        "pl",
        { sensitivity: "base" }
      )
    );

    // 5) render
    return filtered.map(u => (
      <div key={`${u?.uid}-${u?.user?.index}`} style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <WaiterUser u={u} locations={locations} groups={groups} />
        <button onClick={() => openVerifyPopup(u)}>Weryfikuj</button>
      </div>
    ));
  };

  function numberToPolishWeekday(num) {
    const days = {1:"Poniedziałek",2:"Wtorek",3:"Środa",4:"Czwartek",5:"Piątek",6:"Sobota",7:"Niedziela"};
    return days[num] || "Niepoprawny numer dnia (1–7)";
  }

  // ---- LICZNIK wg location_id -> miasto ----
  const LOCATION_CITY_MAP = {
    "1ZYzvEaHWegTVyNk3SqY": "Jastrzębie",
    "PPn4NQOOWZiQo9iOtJPi": "Jastrzębie",
    "jw3A9tNVxgEFSKSW2hHf": "Jastrzębie",
    "pncNRKJn9ByLBqUoVQ5W": "Jastrzębie",
    "uSEC7WdsFajEyyHxcOFe": "Oława",
  };

  const cityCounts = useMemo(() => {
    if (!users || !groups) return {};
    const groupIndex = new Map((groups || []).map(g => [g?.id, g]));
    const counts = {};
    users.forEach(({ user }) => {
      const citiesForUser = new Set();
      (user?.groups || []).forEach(gid => {
        const grp = groupIndex.get(gid);
        const locId = grp?.location_id;
        if (!locId) return;
        const city = LOCATION_CITY_MAP[locId] || "Wrocław";
        citiesForUser.add(city);
      });
      citiesForUser.forEach(city => { counts[city] = (counts[city] || 0) + 1; });
    });
    return counts;
  }, [users, groups]);

  // =====================================================================
  // POPUP WERYFIKACJI
  // =====================================================================
  const [verifyOpen, setVerifyOpen] = useState(false);
  const [target, setTarget] = useState(null);

  const [adult, setAdult] = useState(false);
  const [groupsCount, setGroupsCount] = useState(0);
  const [price, setPrice] = useState(0);
  const [contractType, setContractType] = useState("standard"); // standard | entry | obligation
  const [hasAllSeasonGroup, setHasAllSeasonGroup] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState({}); // {joinRequest, rules, contract, adultContract, parentStatement}

  // NEW: dodatkowe pola do wpisania do sessions
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${mm}-${dd}`;
  });
  const [gender, setGender] = useState(""); // "girl" | "boy" | "woman" | "man" | "" ...
  const [extraInfo, setExtraInfo] = useState("");

  const groupIndex = useMemo(() => new Map((groups || []).map(g => [g?.id, g])), [groups]);
  const getLocationName = (id) => locations?.find(x => x?.id === id)?.name || id || "-";

  const computeInitialType = (u) => {
    const anyAllSeason = (u?.user?.groups || []).some(gid => groupIndex.get(gid)?.allSeason);
    return anyAllSeason ? "obligation" : "standard";
  };

  const computeDefaultDocs = (isAdult, type) => {
    if (type === "entry") {
      return isAdult
        ? { rules:false, joinRequest:false, adultContract:false, contract:false, parentStatement:false }
        : { rules:false, joinRequest:false, adultContract:false, contract:false, parentStatement:true };
    }
    // standard / allSeason
    return isAdult
      ? { adultContract:true, rules:true, joinRequest:true, contract:false, parentStatement:false }
      : { contract:true, parentStatement:true, rules:true, joinRequest:true, adultContract:false };
  };

  const openVerifyPopup = (u) => {
    setTarget(u);
    setGroupsCount(u?.user?.groups?.length || 0);
    setPrice(Number(u?.user?.docs?.contract?.price) || 0);

    const type = computeInitialType(u);
    setContractType(type);

    const anyAllSeason = (u?.user?.groups || []).some(gid => groupIndex.get(gid)?.allSeason);
    setHasAllSeasonGroup(anyAllSeason);

    const isAdult = !!u?.user?.adult;
    setAdult(isAdult);
    setSelectedDocs(computeDefaultDocs(isAdult, type));

    // wstępne podpowiedzi do sessions
    setGender(u?.user?.gender || "");     // jeśli już kiedyś było
    setExtraInfo(u?.user?.info || "");

    // startDate zostawiamy domyślną (dziś) – można zmienić w okienku
    setVerifyOpen(true);
  };

  useEffect(() => {
    if (!verifyOpen) return;
    setSelectedDocs(computeDefaultDocs(adult, contractType));
  }, [adult, contractType, verifyOpen]);

  const toggleDoc = (key) => setSelectedDocs(prev => ({ ...prev, [key]: !prev[key] }));

  // === helper: pobranie sesji dla wielu group_id od wskazanej daty (włącznie)
  const fetchSessionsForGroupsFromDate = async (facilityId, groupIds = [], fromDate /* YYYY-MM-DD */) => {
    if (!facilityId || !Array.isArray(groupIds) || groupIds.length === 0) return [];

    // dziel na paczki max 10 elementów dla operatora "in"
    const batches = [];
    for (let i = 0; i < groupIds.length; i += 10) {
      const slice = groupIds.slice(i, i + 10);
      const q1 = query(
        collection(db, "sessions"),
        where("facility_id", "==", facilityId),
        where("group_id", "in", slice),
        where("date", ">=", fromDate)
      );
      batches.push(getDocs(q1));
    }

    const results = [];
    const snaps = await Promise.all(batches);
    snaps.forEach(snap => {
      snap.forEach(docSnap => {
        results.push({ id: docSnap.id, ...docSnap.data() });
      });
    });

    results.sort((a, b) => {
      const ka = (a?.date || "") + (a?.startTime || "");
      const kb = (b?.date || "") + (b?.startTime || "");
      return ka.localeCompare(kb);
    });

    return results;
  };

  const confirmVerification = async () => {
    if (!target) return;

    const includeContract =
      (adult && selectedDocs.adultContract) ||
      (!adult && selectedDocs.contract);

    const finalType = (contractType === "obligation" || hasAllSeasonGroup) ? "obligation" : contractType;

    const contractPayload = includeContract ? {
      groups: Number(groupsCount) || 0,
      price: Number(price) || 0,
      type: finalType === "entry" ? "standard" : finalType  // kontrakt tylko gdy nie entry
    } : undefined;

    const required = Object.entries(selectedDocs).filter(([,v]) => v).map(([k]) => k);
    const idx = target?.user?.index;

    // 1) Zapis ustawień w userze
    await setDoc(
      doc(db, "users2026", target?.uid),
      {
        subUsers: {
          [idx]: {
            adult: !!adult,
            gender: gender || null,
            info: extraInfo || "",
            toVerificate: false,
            docs: {
              required,
              ...(contractPayload ? { contract: contractPayload } : {})
            }
          }
        }
      },
      { merge: true }
    );

    // 2) Dodanie do sesji od startDate
    const facilityId = target?.acc?.facility_id;
    const userGroupIds = Array.isArray(target?.user?.groups) ? target.user.groups : [];
    try {
      const sessions = await fetchSessionsForGroupsFromDate(facilityId, userGroupIds, startDate);

      // dopisuj tylko, jeśli jeszcze go nie ma w tablicy users (po uid)
      const userEntry = {
        displayName: target?.user?.displayName || "",
        gender: gender || "",           // z formularza
        info: extraInfo || "",
        phone: target?.acc?.parent?.phone || "",
        toBe: false,
        uid: target?.uid || ""
      };

      for (const s of sessions) {
        try {
          const already = Array.isArray(s?.users) && s.users.some(it => it?.uid === userEntry.uid);
          if (already) continue;

          const ref = doc(db, "sessions", s.id);
          await updateDoc(ref, {
            users: arrayUnion(userEntry)
          });
        } catch (e) {
          console.error("Błąd dodawania do sesji", s?.id, e);
        }
      }
    } catch (e) {
      console.error("Błąd przy pobieraniu/dodawaniu do sesji:", e);
    }

    setVerifyOpen(false);
    setTarget(null);
  };

  const subGroups = useMemo(() => {
    if (!target) return [];
    return (target?.user?.groups || [])
      .map(id => groupIndex.get(id))
      .filter(Boolean);
  }, [target, groupIndex]);

  return (
    <div className={isToogle ? "side-toogle-margin" : "side-margin"}
         style={{display:"flex",justifyContent:"flex-start",alignItems:"flex-start",flexDirection:"column",minHeight:"100vh",overflowY:"scroll",gap:"15px",paddingTop:"20px",paddingBottom:"20px"}}>

      <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",width:"100%",gap:"20px"}}>
        <div style={{display:"flex",flexDirection:"column",justifyContent:"flex-start",alignItems:"flex-start",position:"relative",width:"100%",gap:'5px',maxWidth:"800px"}}>

          <div className="mobile-column" style={{display:"flex",justifyContent:"center",alignItems:"center",position:"relative",width:"100%",gap:'5px'}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"flex-start",position:"relative",width:"60%",maxWidth:"480px"}}>
              <input value={searcher} type="text" className="searcher-input" placeholder="Wyszukaj klienta"
                     style={{height:"20px",padding:"7px",width:"100%",outline:"none",fontWeight:"bold",backgroundColor:"rgb(0,0,0,0)",color:"rgb(70,70,70)",fontSize:"12px",borderRadius:"5px",paddingLeft:"35px",border:"1px solid rgb(30,30,30,0.25)"}}
                     onChange={(e) => setSearcher(e?.target?.value)} />
              <img src="searcher-blue.png" style={{width:"15px",position:"absolute",top:"11px",left:'3%'}} alt="" />
            </div>

            <div style={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center",width:"400px",gap:"10px"}}>
              <select className='searcher' value={actualGroup} onChange={(e) => setActualGroup(e.target.value)}
                      style={{height:"37.5px",padding:"7px",maxWidth:"320px",outline:"none",fontWeight:"bold",backgroundColor:"rgb(0,0,0,0)",border:"1px solid rgb(30,30,30,0.25)",color:"rgb(100,100,100)",fontSize:"12px",borderRadius:"5px"}}>
                <option value={""} key={-1}>Wybierz grupę</option>
                {(groups && locations) && Object.values(groups)
                  .sort((a,b) => {
                    const nameA = locations?.find(x => x?.id === a?.location_id)?.name || "";
                    const nameB = locations?.find(x => x?.id === b?.location_id)?.name || "";
                    return nameA.localeCompare(nameB);
                  })
                  .map((group, index) => (
                    <option value={group?.id} key={index}>
                      {locations?.find(x => x?.id === group?.location_id)?.name}
                      {" - "}
                      {group?.days?.[0]?.custom_name
                        ? group?.days?.[0]?.custom_name
                        : `${numberToPolishWeekday(group?.days?.[0]?.weekDay)} - ${group?.days?.[0]?.startTime} - ${group?.days?.[0]?.endTime} - ${group?.type}`}
                    </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* LICZNIKI */}
        {users &&
          <div style={{display:"flex",flexDirection:"row",justifyContent:"space-around",alignItems:"center",border:"1px solid rgb(30,30,30,0.25)",padding:"15px 20px",width:"87.5%",height:"30px",borderRadius:"5px",marginBottom:"5px"}}>
            <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
              <h3 style={{fontSize:"14px",color:"rgb(30,30,30)"}}>{userList()?.length}</h3>
              <h3 style={{fontSize:"12px",color:"rgb(30,30,30, 0.6)"}}>Ilość uczestników</h3>
            </div>
            <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
              <h3 style={{fontSize:"14px",color:"rgb(30,30,30)"}}>{cityCounts["Wrocław"] || 0}</h3>
              <h3 style={{fontSize:"12px",color:"rgb(30,30,30, 0.6)"}}>Wrocław</h3>
            </div>
            <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
              <h3 style={{fontSize:"14px",color:"rgb(30,30,30)"}}>{cityCounts["Oława"] || 0}</h3>
              <h3 style={{fontSize:"12px",color:"rgb(30,30,30, 0.6)"}}>Oława</h3>
            </div>
            <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
              <h3 style={{fontSize:"14px",color:"rgb(30,30,30)"}}>{cityCounts["Jastrzębie"] || 0}</h3>
              <h3 style={{fontSize:"12px",color:"rgb(30,30,30, 0.6)"}}>Jastrzębie</h3>
            </div>
          </div>
        }

        {/* LISTA */}
        {users && userList()}
        {users && <h3 style={{fontSize:"12px",color:"rgb(30,30,30, 0.6)"}}>Ilość wyników: {userList()?.length}</h3>}
      </div>

      {/* ========================= POPUP: WERYFIKUJ ========================= */}
      {verifyOpen &&
        <div
          style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"10px",width:"100%",height:"100%",transition:"0.5s",backgroundColor:"rgb(30,30,30,0.5)",position:"fixed",top:0,left:0,zIndex:3000}}
          onClick={() => setVerifyOpen(false)}
        >
          <div
            style={{display:"flex",justifyContent:"flex-start",alignItems:"stretch",flexDirection:"column",gap:"14px",width:"min(980px, 92vw)",minHeight:"360px",transition:"0.5s",backgroundColor:"rgb(250,250,250)",borderRadius:"12px",padding:"18px 20px"}}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <h3 style={{fontSize:"16px",color:"rgb(30,30,30)",fontWeight:"bold"}}>Weryfikacja</h3>
              <h3 style={{fontSize:"13px",color:"rgb(100,100,100)"}}>
                {target?.user?.displayName} · UID: {target?.uid}
              </h3>
            </div>

            <div style={{display:"grid",gridTemplateColumns:"1fr 0.9fr 1.2fr",gap:"16px"}} onClick={(e) => e.stopPropagation()}>
              {/* LEWA: konfiguracja */}
              <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
                <label style={{fontSize:"12px",color:"rgb(60,60,60)"}}>Liczba grup</label>
                <input type="number" min={0} value={groupsCount}
                  onChange={e => setGroupsCount(e.target.value)}
                  style={{height:36,padding:"6px 10px",border:"1px solid rgba(0,0,0,.2)",borderRadius:6,fontSize:13}} />

                <label style={{fontSize:"12px",color:"rgb(60,60,60)"}}>Cena miesięczna (PLN)</label>
                <input type="number" min={0} value={price}
                  onChange={e => setPrice(e.target.value)}
                  style={{height:36,padding:"6px 10px",border:"1px solid rgba(0,0,0,.2)",borderRadius:6,fontSize:13}} />

                <label style={{fontSize:"12px",color:"rgb(60,60,60)"}}>Typ umowy</label>
                <select
                  value={hasAllSeasonGroup ? "obligation" : contractType}
                  onChange={e => setContractType(e.target.value)}
                  disabled={hasAllSeasonGroup}
                  style={{height:36,padding:"6px 10px",border:"1px solid rgba(0,0,0,.2)",borderRadius:6,fontSize:13,backgroundColor: hasAllSeasonGroup ? "rgb(245,245,245)" : "white"}}
                >
                  <option value="standard">Standard</option>
                  <option value="entry">Wejście jednorazowe</option>
                  <option value="obligation">Bez wypowiedzenia (sezon)</option>
                </select>

                {hasAllSeasonGroup &&
                  <div style={{fontSize:12,color:"rgb(120,120,120)"}}>
                    Wykryto grupę z atrybutem <b>obligation</b> – typ umowy ustawiony na „Bez wypowiedzenia”.
                  </div>
                }

                <label style={{display:"flex",alignItems:"center",gap:8,marginTop:6,fontSize:13,color:"rgb(40,40,40)"}}>
                  <input type="checkbox" checked={adult} onChange={() => setAdult(a => !a)} />
                  Osoba dorosła
                </label>

                {/* NEW: Data startu dla sessions */}
                <label style={{fontSize:"12px",color:"rgb(60,60,60)", marginTop: 6}}>Data startu (od tej daty doda do zajęć)</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                  style={{height:36,padding:"6px 10px",border:"1px solid rgba(0,0,0,.2)",borderRadius:6,fontSize:13}}
                />

                {/* NEW: Płeć i dodatkowe informacje (do sessions) */}
                <label style={{fontSize:"12px",color:"rgb(60,60,60)", marginTop: 6}}>Płeć</label>
                <select
                  value={gender}
                  onChange={e => setGender(e.target.value)}
                  style={{height:36,padding:"6px 10px",border:"1px solid rgba(0,0,0,.2)",borderRadius:6,fontSize:13}}
                >
                  <option value="">— wybierz —</option>
                  <option value="girl">dziewczynka</option>
                  <option value="boy">chłopiec</option>
                  <option value="woman">kobieta</option>
                  <option value="man">mężczyzna</option>
                </select>

                <label style={{fontSize:"12px",color:"rgb(60,60,60)"}}>Informacje dodatkowe</label>
                <textarea
                  value={extraInfo}
                  onChange={e => setExtraInfo(e.target.value)}
                  rows={3}
                  style={{padding:"8px 10px",border:"1px solid rgba(0,0,0,.2)",borderRadius:6,fontSize:13,resize:"vertical"}}
                  placeholder="np. uwagi, preferencje..."
                />
              </div>

              {/* ŚRODEK: dokumenty */}
              <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
                <h4 style={{fontSize:13,margin:"0 0 4px"}}>Dokumenty do przypisania</h4>
                <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13}}>
                  <input type="checkbox" checked={!!selectedDocs.joinRequest} onChange={() => toggleDoc("joinRequest")} />
                  Wniosek o dołączenie
                </label>
                <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13}}>
                  <input type="checkbox" checked={!!selectedDocs.rules} onChange={() => toggleDoc("rules")} />
                  Oświadczenie dot. regulaminu
                </label>
                {!adult && (
                  <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13}}>
                    <input type="checkbox" checked={!!selectedDocs.contract} onChange={() => toggleDoc("contract")} />
                    Umowa (niepełnoletni)
                  </label>
                )}
                {adult && (
                  <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13}}>
                    <input type="checkbox" checked={!!selectedDocs.adultContract} onChange={() => toggleDoc("adultContract")} />
                    Umowa (dorosły)
                  </label>
                )}
                {!adult && (
                  <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13}}>
                    <input type="checkbox" checked={!!selectedDocs.parentStatement} onChange={() => toggleDoc("parentStatement")} />
                    Oświadczenie rodzica
                  </label>
                )}
              </div>

              {/* PRAWA: dane i grupy */}
              <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
                <h4 style={{fontSize:13,margin:"0 0 4px"}}>Dane subusera</h4>
                <div style={{fontSize:12,color:"#333"}}>
                  <div><b>Imię i nazwisko:</b> {target?.user?.displayName || "-"}</div>
                  <div><b>PESEL:</b> {target?.user?.pesel || "-"}</div>
                  <div><b>Data ur.:</b> {target?.user?.dateOfBirth || "-"}</div>
                  <div><b>Dorosły:</b> {adult ? "tak" : "nie"}</div>
                </div>

                <h4 style={{fontSize:13,margin:"8px 0 4px"}}>Dane rodzica/opiekuna</h4>
                <div style={{fontSize:12,color:"#333"}}>
                  <div><b>Imię i nazwisko:</b> {target?.acc?.parent?.displayName || "-"}</div>
                  <div><b>Telefon:</b> {target?.acc?.parent?.phone || "-"}</div>
                  <div><b>E-mail:</b> {target?.acc?.email || "-"}</div>
                </div>

                <h4 style={{fontSize:13,margin:"8px 0 4px"}}>Grupy subusera</h4>
                <div style={{border:"1px solid rgba(0,0,0,.08)",borderRadius:8,padding:"6px 8px",maxHeight:180,overflow:"auto"}}>
                  {subGroups.length === 0 && <div style={{fontSize:12,color:"#777"}}>Brak przypisanych grup</div>}
                  {subGroups.map((g, i) => (
                    <div key={g?.id || i}
                         style={{display:"grid",gridTemplateColumns:"1.2fr 1fr 1fr auto",gap:8,alignItems:"center",padding:"6px 0",borderBottom:"1px dashed rgba(0,0,0,.08)"}}>
                      <div style={{fontSize:12,color:"#111"}}>{getLocationName(g?.location_id)}</div>
                      <div style={{fontSize:12,color:"#333"}}>
                        {g?.days?.[0]?.custom_name
                          ? g?.days?.[0]?.custom_name
                          : `${numberToPolishWeekday(g?.days?.[0]?.weekDay)} ${g?.days?.[0]?.startTime}–${g?.days?.[0]?.endTime}`}
                      </div>
                      <div style={{fontSize:12,color:"#555"}}>{g?.type || "-"}</div>
                      <div style={{fontSize:11,color:g?.allSeason ? "#0045C7" : "#999",fontWeight:g?.allSeason?700:500}}>
                        {g?.allSeason ? "obligation" : ""}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:6}}>
              <button className="button-white" onClick={() => setVerifyOpen(false)}>Anuluj</button>
              <button className="button-black" onClick={confirmVerification}>Zatwierdź</button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}
